import { memo, useMemo } from 'react'
import { filterGroupToExpression } from './criteriaUtils'
import type { FilterGroup } from '@/types'

interface FormulaPreviewProps {
  group: FilterGroup
  fieldLabels: Record<string, string>
  valueLabels?: Record<string, string>
}

export const FormulaPreview = memo(function FormulaPreview({
  group,
  fieldLabels,
  valueLabels,
}: FormulaPreviewProps) {
  const expression = useMemo(
    () => filterGroupToExpression(group, fieldLabels, valueLabels),
    [group, fieldLabels, valueLabels]
  )

  if (!expression) return null

  return (
    <div className="rounded-md bg-muted/50 border border-border px-3 py-2">
      <code className="text-xs text-muted-foreground break-all">
        {expression}
      </code>
    </div>
  )
})
